import { Component, OnInit } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';
import { MainService } from 'src/app/services/main.service';

export interface PendingSalesModel {
  title: string;
  item: any;
}

@Component({
  selector: 'app-pending-sales',
  templateUrl: './pending-sales.component.html',
  styleUrls: ['./pending-sales.component.css']
})

export class PendingSalesComponent extends DialogComponent<PendingSalesModel, boolean>
  implements PendingSalesModel, OnInit {

  orderData$: Observable<any>;
  title: string;
  item: any;
  result: any = { result: false, RtnItem: {} };
  cols: any;
  locId = 1;
  data: any = [];
  selectedItem: any = { OrderNo: '' };

  constructor(dialogService: DialogService, private pos: PosService,
    private f_db: AngularFireDatabase, private ms: MainService) {
    super(dialogService);
  }

  ngOnInit() {

    this.cols = [
      { field: 'OrderNo', header: 'Order No', f: 'text' },
      { field: 'OrderDate', header: 'Order Date', f: 'date' },
      { field: 'TotalAmount', header: 'Amount', f: 'decimal' },
      { field: 'CustomerName', header: 'Customer Name', f: 'text' },
      { field: 'CustomerName', header: 'Customer Name', f: 'text' },
      { field: 'EcomOrderTypeName', header: 'Order Type', f: 'text' }
    ];

    this.f_db.list(this.ms.CommonSetting.StoreCode).valueChanges().subscribe(res => {
      this.data = [];
      for (const i of res) {
        var dx = Object.assign({}, i);
        dx["IsNew"] = true;
        dx["EcomOrderTypeName"] = "New Order";
        this.data.push(dx);
      }
      this.loadData();
    });
  }

  loadData() {
    this.pos.GetSalesOrderByStatus({ Status: '1', LocationId: this.locId })
      .subscribe(res => {
        if (res.Success) {
          for (const i of res.data) {
            var dx = Object.assign({}, i);
            dx.IsNew = false;
            dx["EcomOrderTypeName"] = "Order";
            this.data.push(dx);
          }
        }
      });
  }

  LoadSales() {
    var model = Object.assign({}, this.selectedItem);
    if (model.IsNew) {
      this.pos.SaveSalesOrder(model)
        .subscribe(res => {
          if (res.Success) {
            this.result.result = true;
            this.result.RtnItem = res.data;
            this.f_db.list(`${this.ms.CommonSetting.StoreCode}/${model.OrderNo}`).remove();
            this.close();
          }
        });
    } else {
      this.result.result = true;
      this.result.RtnItem = model;
      this.close();
    }
  }

  onRowSelect(e) {
    this.selectedItem = e.data;
  }

}
